import { render } from "./Login.vue?vue&type=template&id=2ad8646c&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=2ad8646c&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad8646c"]])

export default __exports__